import React from "react";
import Products from "../components/Products";

const Home = () => {
  return (
    <>
      <Products />
    </>
  );
};

export default Home;
